var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospital2Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#C4EAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87457 9.37936H9.38772V5.87591C9.38772 5.39296 9.77888 5.0009 10.2618 5.0009H13.7583C14.2404 5.0009 14.6315 5.39286 14.6315 5.87591V9.37856H18.1262C18.6101 9.37856 19.0013 9.76972 19.0013 10.2536V13.7544C19.0013 14.2392 18.6101 14.6311 18.1262 14.6311H14.6315V18.1241C14.6315 18.6079 14.2403 18.9991 13.7583 18.9991H10.2618C9.77888 18.9991 9.38772 18.6079 9.38772 18.1241V14.6311H5.87457C5.39072 14.6311 4.99866 14.2392 4.99866 13.7544V10.2536C4.99866 9.77052 5.39072 9.37936 5.87457 9.37936Z",
    fill: "#16B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital2Svg);
export default __webpack_public_path__ + "static/media/Hospital2Svg.eb24e451a933de015d17568a11488f35.svg";
export { ForwardRef as ReactComponent };